<template>
    <div class="container-fluid">
        <div class="row">
            <pagelist />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const pagelist = defineAsyncComponent(() => import("@/components/theme/ecommerce/addpagelist/pagelist.vue"))
</script>